import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OptimaService } from 'src/app/core/services/optima.service';
import { UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UtenteService } from 'src/app/services/users/utente.service';

@Component({
  selector: 'app-optima-smart',
  templateUrl: './optima-smart.component.html',
  styleUrls: ['./optima-smart.component.css']
})
export class OptimaSmartComponent implements OnInit {

  userInfo: any;
  fatturazione: boolean = false;
  consulenza: boolean = false;
  timbratura: boolean = false;
  conservazione: boolean = false;
  archoptima: boolean = false;

  constructor(
    public utenteServices: UtenteService,
    public optimaService: OptimaService,
    public router: Router,
    private toast : ToastService
  ) { }

  async ngOnInit(): Promise<void> {
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");

    this.utenteServices.getServiziAttivi(this.userInfo!.user_id).then(
      (res) => {
        if (res.data.length > 0) {
          res.data.forEach((servizio: any) => {
            switch(servizio.service_name) {
              case 'fatturazione':
                this.fatturazione = true;
                break;
              case 'consulenza':
                this.consulenza = true;
                break;
              case 'timbratura':
                this.timbratura = true;
                break;
              case 'conservazione':
                this.conservazione = true;
                break;
              case 'archoptima':
                this.archoptima = true;
                break;
            }
          });
        }
      }
    );
  }

  apriFatturazione() {
    this.router.navigate(['/main/dashboard']);
  }

  apriConservazione() {
    this.router.navigate(['/conservazione']);
  }

  apriArchOptima() {
    this.router.navigate(['/archoptima']);
  }

  apriAmministrazione() {
    this.router.navigate(['/amministrazione']);
  }

  richiediInformazioni(service: string) {
    this.optimaService.richiediInformazioni(this.userInfo!.user_id, { servizio: service }).then(
      (res) => {
        if (res.success) {
          this.toast.openToast(res.msg, "success");
        } else {
          this.toast.openToast(res.msg, "warning");
        }
      }
    );
  }

}
